import { Checkbox, Collapse, DatePicker, Form, Input, InputNumber, notification, Select, Space, Spin, Tag } from "antd";
import type { InputRef, SelectProps } from 'antd';
import { ChangeEvent, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import { ActionResult, Query } from "../../common/hooks/useApi";
import useEquiposRadarAPI, { Equipo } from "../../equipos/useEquiposAPI";
import { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";

//import 'moment/locale/es-mx';
import locale from 'antd/es/date-picker/locale/es_ES'
import moment from "moment";
import { useForm } from "antd/lib/form/Form";
import InputUbicacion from "../../titulares-vehiculo/components/InputUbicacion";
import TagInput from "../../common/components/TagInput";
import useCodigosInfraccionAPI, { CodigoInfraccion, CodigoInfraccionSave, formatDescripcionCodigoInfraccion } from "../../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import ConfiguracionProduccionSave from "../../configuraciones-produccion/ConfiguracionProduccionSave";
import useConfiguracionesProduccionAPI from "../../configuraciones-produccion/useConfiguracionesProduccionAPI";
import Title from "antd/lib/skeleton/Title";
import { set } from "lodash";


// moment.updateLocale('es-mx', {
//     week: {
//         dow: 1
//     },

// });


const FiltroEquipos = styled.div`
display: grid;
grid-template-columns: 1fr 1fr;
grid-gap:1rem;
margin-bottom:1rem;
`;
const FiltroContainer = styled.div`
padding: 0.75rem;
background: #e0e0e0;
box-shadow: rgb(0 0 0 / 10%) 0px 1px 3px 0px, rgb(0 0 0 / 6%) 0px 1px 2px 0px;
display: grid;
grid-template-rows: auto 1fr;
`;
const FiltroHeader = styled.div`
display: grid;
grid-gap: 1rem;
border-bottom: 1px solid #616161;
padding-bottom: 1rem;
margin-bottom:1rem;

& + *
{
    max-height:110px;
    overflow:auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.5rem;
    line-height: 1.2;
    & > label
    {
        margin-left:0!important;
    }
}
`;

const HeaderFiltroXCodigo = styled.div`
border-bottom: 1px solid #616161;
padding-bottom: 1rem;
margin-bottom:1rem;
`;


const FiltroUbicacion = styled.div`
display: grid;
grid-template-columns: 1.2fr repeat(3, 1fr);
grid-gap: 1rem;
`;

const FiltroCiudadExcluir = styled.div`
display: grid;
grid-template-columns: 0.8fr repeat(3, 1fr);
margin-top: -1rem;
margin-bottom: -1.5rem;
`;

const FiltroCiudadIncluir = styled.div`
display: grid;
grid-template-columns: 0.8fr repeat(2, 1fr);
margin-top: -1rem;
margin-bottom: -1.5rem;
`;

const FiltrosExtra = styled(Form)`
& > div:first-child
{
    display: grid;
    /* grid-template-columns: 1fr 1fr auto 150px; */
    grid-template-columns: 1fr minmax(100px,auto) minmax(100px, 200px);
    grid-gap: 1rem;
    align-items:center;
   
}


 margin-top:2em;
 margin-bottom:2em;
display: grid;
grid-gap: 1rem;
/* background: black; */
/* color: white; */
padding: 1rem;
/* border: 1px solid #fafafa; */
background: #c5c5c5ff;
border-radius: 5px;
`;

const EmptyEquipos = styled.div`
display: flex;
align-items: center;
justify-content: center;
`;

const FiltroVelocidad = styled.div`
display: grid;
grid-template-columns: 1fr 1fr;
grid-gap: 1rem;
`;

const FiltrosExtraFooter = styled.div`
display:flex;
align-items:center;
justify-content:right;
gap: 1rem;
`;

const StyledSpinDiv = styled.div`
display: flex;
align-items: center;
justify-content: center;
`;

const TotalResultados = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  
  p {
    margin-right: 0.3rem;
    color: #e94848;
    font-weight: bold;
  }
`;

const StyledSpin = styled(Spin)`
margin-left:0.5rem;
`;

interface FilterProps {
    infractorFilterType?: (0 | 1)
    infractorCodigoPostal?: { Nombre: string }[]
    infractorProvincia?: string
    maxMeasure?: number
    minMeasure?: number
    dateRange: moment.Moment[]
    limit?: number
    filterExcluirParanaenses?: boolean;
    filterExcluirSantaFe?: boolean;
    filterExcluirRosario?: boolean;
    filterIncluirSantaFe?: boolean;
    filterIncluirRosario?: boolean;
};

export interface FiltroInfraccionesProps {
    //onConfirm: (query: Query) => Promise<any>,
    //onChange: (query: Query, count: number | undefined) => any
    onChange: (query: Query) => any
    onChangeCount: (count: number | undefined) => any
    onChangeLoading: (loading: boolean) => any
    baseFilter?: string[]
    count: (query: Query) => Promise<ActionResult<number> | undefined>
    children?: React.ReactNode
    ubicacionInfractorFilter?: boolean
    ciudadesInfractorFilter?: boolean
    onChangeUnidadesProd?: (ids: number[] | UnidadProduccion[]) => any
};


export interface FiltroInfraccionesRef {
    loadTotal: () => Promise<void>
    count?: number
    filter?: FilterProps
}

export default forwardRef<FiltroInfraccionesRef, FiltroInfraccionesProps>((props, ref) => {

    const api = useEquiposRadarAPI();
    const codigoInfraccionApi = useCodigosInfraccionAPI();
    const configuracionProduccionApi = useConfiguracionesProduccionAPI();

    const [total, setTotal] = useState<number | undefined>();

    const [equiposResponse, setEquiposResponse] = useState<ActionResult<Equipo[]>>();
    const [selectedUnidadesProduccion, setSelectedUnidadesProduccion] = useState<UnidadProduccion[]>([]);
    const [selectedEquipos, setSelectedEquipos] = useState<Equipo[]>([]);
    //const [maxSpeed, setMaxSpeed] = useState<string | undefined>();
    //const [minSpeed, setMinSpeed] = useState<string | undefined>();
    const [filter, setFilter] = useState<FilterProps>();
    const [form] = useForm<FilterProps>();
    const [loadingTotal, setLoadingTotal] = useState(false);
    const totalQueryTimeout = useRef<ReturnType<typeof setTimeout> | undefined>();
    const firstTotalQuery = useRef<boolean>(true);
    const [showConfigPruebas, setshowConfigPruebas] = useState<boolean>(false);
    const [codigosInfraccion, setCodigosInfraccion] = useState<CodigoInfraccion[]>([]);
    const options: [{ label: string; value: string }] = [{ label: "", value: "" }];
    const [codigoInfraccionSeleccionado, setCodigoInfraccionSeleccionado] = useState<number | null>(null);
    const [keySelectCodigoInfraccion, setKeySelectCodigoInfraccion] = useState<any>(0);

    useEffect(() => {
        if (!showConfigPruebas && process.env.REACT_APP_UNIDADES_PROD_PRUEBA != "") {
            api
                .list({
                    $top: 1000,
                    $expand: ["ConfiguracionProduccion($expand=UnidadProduccion)"],
                    $filter: [`ConfiguracionProduccion/UnidadProduccion/Id in (${process.env.REACT_APP_UNIDADES_PROD_PRUEBA}) eq false`]
                })
                .then((response) => setEquiposResponse(response));
        } else {
            api
                .list({
                    $top: 1000,
                    $expand: ["ConfiguracionProduccion($expand=UnidadProduccion)"],
                })
                .then((response) => setEquiposResponse(response));
        }

        window.addEventListener('keydown', handleUserKeyPress);
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress);
        };
    }, [showConfigPruebas]);

    const handleUserKeyPress = (e: any) => {
        if (e.altKey && e.key === "p") {
            e.preventDefault();
            setshowConfigPruebas(true)
            notification.success({
                message: 'Mostrando configuraciones de prueba...',
                duration: 1.5,
                placement: 'topRight'
            })
        } else if (e.altKey && e.key === "o") {
            e.preventDefault();
            setshowConfigPruebas(false)
            notification.info({
                message: 'Ocultando configuraciones de prueba...',
                duration: 1.5,
                placement: 'topRight'
            })
        }
    };

    const getUnidadesProduccion = () => {
        const unidadesProduccion: { [key: number]: UnidadProduccion } = {};
        equiposResponse?.data?.value.forEach((equipo) => {
            unidadesProduccion[equipo.ConfiguracionProduccion.UnidadProduccionId] = equipo.ConfiguracionProduccion.UnidadProduccion;
        });
        return Object.values(unidadesProduccion);
    };

    const onChangeUnidadProduccionCheckbox = (checked: boolean, unidadProduccion: UnidadProduccion) => {
        if (checked) {
            setSelectedUnidadesProduccion([...selectedUnidadesProduccion, ...[unidadProduccion]]);
        }
        else {
            setSelectedUnidadesProduccion(selectedUnidadesProduccion.filter(u => u.Id != unidadProduccion.Id));
            setSelectedEquipos(selectedEquipos.filter(e => e.ConfiguracionProduccion.UnidadProduccionId != unidadProduccion.Id));
        }
    };

    const onChangeEquipoCheckbox = (checked: boolean, equipo: Equipo) => {
        if (checked) {
            setSelectedEquipos([...selectedEquipos, ...[equipo]]);
        }
        else {
            setSelectedEquipos(selectedEquipos.filter(e => e.Id != equipo.Id));
        }
    };

    const onChangeSelectAllUnidadProduccionCheckbox = (checked: boolean) => {
        const unidadesProduccion = getUnidadesProduccion();
        if (checked) {
            setSelectedUnidadesProduccion(unidadesProduccion);
        }
        else {
            setSelectedUnidadesProduccion([]);
            setSelectedEquipos([]);
        }
    };

    const onChangeSelectAllEquiposCheckbox = (checked: boolean) => {
        const equipos = equiposResponse?.data?.value!.filter(e => selectedUnidadesProduccion.some(u => u.Id == e.ConfiguracionProduccion.UnidadProduccionId));
        if (checked) {
            setSelectedEquipos(equipos!);
        }
        else {
            setSelectedEquipos([]);
        }
    };

    /*
    const onConfirm = async (values: FilterProps) => {
        await props.onConfirm(getQuery());
    };*/


    useEffect(() => {
        if (!firstTotalQuery.current) {
            if (totalQueryTimeout.current) {
                clearTimeout(totalQueryTimeout.current);
            }

            setLoadingTotal(true);

            totalQueryTimeout.current = setTimeout(async () => {
                await loadTotal();
            }, 1000);

            props.onChange(getQuery());
        }
        else {
            firstTotalQuery.current = false;
        }
    }, [selectedEquipos, selectedUnidadesProduccion, filter, codigoInfraccionSeleccionado]);

    useEffect(() => {
        props.onChangeLoading(loadingTotal);
    }, [loadingTotal]);

    useEffect(() => {
        props.onChangeCount(total);
    }, [total]);

    useEffect(() => {
        props.onChangeUnidadesProd!(selectedUnidadesProduccion);
        setKeySelectCodigoInfraccion(Date.now());
        if (selectedUnidadesProduccion.length === 1) {
            setCodigosInfraccion([]);
            setCodigoInfraccionSeleccionado(null);
            options.push({ label: "", value: "" });
            codigoInfraccionApi.codigoInfraccionPorUnidadProduccion(selectedUnidadesProduccion[0]?.Id!).then(res => {
                if (res.data) {
                    setCodigosInfraccion(res.data);
                    res.data.forEach(element => {
                        options.push({ label: formatDescripcionCodigoInfraccion(element), value: element.id.toString() });
                    });
                }
            });
        } else {
            setCodigosInfraccion([]);
            setCodigoInfraccionSeleccionado(null);
            options.push({ label: "", value: "" });
        }

    }
        , [selectedUnidadesProduccion]);



    const getQuery = (): Query => {

        const filters = [
            `EquipoId in (${selectedEquipos.length ? selectedEquipos.map(e => `'${e.Id}'`).join() : `'0'`})`,
            filter?.maxMeasure ? `ValorMedido le ${filter.maxMeasure}` : '',
            filter?.minMeasure ? `ValorMedido ge ${filter.minMeasure}` : '',
            filter?.dateRange ? `FechaHora ge ${filter.dateRange[0]/*.utc()*/.startOf("day").toISOString()} and FechaHora le ${filter.dateRange[1]/*.utc()*/.endOf("day").toISOString()}` : ''
        ];

        if (filter?.infractorFilterType != undefined) {
            if (filter.infractorFilterType === 0) {
                const orFilter = [
                    filter?.infractorCodigoPostal ? `not Titular/CodigoPostalTitular in (${filter.infractorCodigoPostal.map(t => `'${t.Nombre}'`)})` : '',
                    filter?.infractorProvincia ? `Titular/ProvinciaTitular ne '${filter.infractorProvincia}'` : ''
                ].filter(f => f != "");
                filters.push(`(${orFilter.join(" or ")})`);
            }
            else {

                filters.push(filter?.infractorCodigoPostal ? `Titular/CodigoPostalTitular in (${filter.infractorCodigoPostal.map(t => `'${t.Nombre}'`)})` : '');
                filters.push(filter?.infractorProvincia ? `Titular/ProvinciaTitular eq '${filter.infractorProvincia}'` : '');
            }
        }

        const excludedPostalCodes = [
            { value: filter?.filterExcluirParanaenses, postalCode: ['3100', '3101', '3105', '3107', '3120'], id: 'Paranaenses' },
            { value: filter?.filterExcluirRosario, postalCode: '2000', id: 'Rosario' },
            { value: filter?.filterExcluirSantaFe, postalCode: '3000', id: 'SantaFe' }
        ];


        excludedPostalCodes.forEach(({ value, postalCode, id }) => {
            if (value) {
                if (id === 'Paranaenses') {
                    filters.push(`not Titular/CodigoPostalTitular in ('3100', '3101', '3105', '3107', '3120')`)
                } else {
                    filters.push(`Titular/CodigoPostalTitular ne '${postalCode}'`);
                }
            }
        });

        const includedPostalCodes = [
            { value: filter?.filterIncluirRosario, postalCode: '2000' },
            { value: filter?.filterIncluirSantaFe, postalCode: '3000' }
        ];

        includedPostalCodes.forEach(({ value, postalCode }) => {
            if (value) {
                filters.push(`Titular/CodigoPostalTitular eq '${postalCode}'`);
            }
        });

        if(codigoInfraccionSeleccionado){
            filters.push(`CodigoInfraccionId eq ${codigoInfraccionSeleccionado}`);
        }


        const query: Query = {
            $count: true,
            $filter: [
                ...filters.filter(f => f != ""),
                ...(props.baseFilter ?? [])
            ]
        };
        if (filter?.limit) {
            query.$top = filter.limit;
        }
        return query;
    };

    const loadTotal = async () => {

        setLoadingTotal(true);

        const queryCount = getQuery();
        delete queryCount.$top;
        const total = (await props.count(queryCount))?.data?.value;//(await apiInfracciones.getPendingCount(getQuery())).data?.value;

        setTotal(total);
        setLoadingTotal(false);
    };


    useImperativeHandle(ref, () => ({
        loadTotal,
        filter
    }));

    return (
        <>
            <FiltroEquipos>
                <FiltroContainer>
                    <FiltroHeader>
                        <strong>Unidades de producción</strong>
                        <Checkbox
                            indeterminate={selectedUnidadesProduccion.length > 0 && selectedUnidadesProduccion.length != getUnidadesProduccion().length}
                            checked={selectedUnidadesProduccion.length > 0 && selectedUnidadesProduccion.length == getUnidadesProduccion().length}
                            onChange={(e) => onChangeSelectAllUnidadProduccionCheckbox(e.target.checked)}>
                            Seleccionar todo
                        </Checkbox>
                    </FiltroHeader>
                    {
                        !equiposResponse && (
                            <StyledSpinDiv>
                                <StyledSpin size="default" />
                            </StyledSpinDiv>
                        )
                    }
                    <div>
                        {getUnidadesProduccion()
                            .map(unidadProduccion =>
                                <Checkbox checked={selectedUnidadesProduccion.some(u => u.Id == unidadProduccion.Id)} key={unidadProduccion.Id} onChange={(e) => onChangeUnidadProduccionCheckbox(e.target.checked, unidadProduccion)}>
                                    {unidadProduccion.Nombre}
                                </Checkbox>)}
                    </div>
                </FiltroContainer>
                <FiltroContainer>
                    <FiltroHeader>
                        <strong>Equipos</strong>
                        {selectedUnidadesProduccion.length > 0 &&
                            <Checkbox
                                onChange={(e) => onChangeSelectAllEquiposCheckbox(e.target.checked)}
                                indeterminate={selectedEquipos.length > 0 && selectedEquipos.length != equiposResponse?.data?.value.length}
                                checked={selectedEquipos.length > 0}
                            >
                                Seleccionar todo
                            </Checkbox>}
                    </FiltroHeader>

                    {selectedUnidadesProduccion.length == 0 && <EmptyEquipos>No hay unidades de producción seleccionadas</EmptyEquipos>}

                    <div>
                        {equiposResponse?.data?.value
                            .filter(e => selectedUnidadesProduccion.some(u => u.Id == e.ConfiguracionProduccion.UnidadProduccionId))
                            .map(equipo =>
                                <Checkbox checked={selectedEquipos.some(e => e.Id == equipo.Id)} key={equipo.Id} onChange={(e) => onChangeEquipoCheckbox(e.target.checked, equipo)}>
                                    {equipo.Nombre} ({equipo.ConfiguracionProduccion.UnidadProduccion.Nombre})
                                </Checkbox>)}
                    </div>
                </FiltroContainer>
            </FiltroEquipos>

            <HeaderFiltroXCodigo>
                <strong>Filtrar por código de infracción</strong>
            </HeaderFiltroXCodigo>

            <Select
                key={keySelectCodigoInfraccion}
                style={{ width: '100%' }}
                onChange={(value) => { setCodigoInfraccionSeleccionado(value) }}
                defaultValue={null}
                disabled={codigosInfraccion.length === 0}
            >
                <Select.Option value={null}>Todos</Select.Option>
                {codigosInfraccion.map((item) => (
                    <Select.Option key={item.id} value={item.id}>{formatDescripcionCodigoInfraccion(item)}</Select.Option>
                ))}
            </Select>

            <FiltrosExtra
                //onFinish={(values) => onConfirm(values as FilterProps)}
                onValuesChange={() => {
                    setFilter(form.getFieldsValue())
                }}
                form={form}
            >

                <div>
                    <FiltroVelocidad>
                        <Form.Item name={"minMeasure"} style={{ marginBottom: 0 }} label="Medición min.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={"maxMeasure"} style={{ marginBottom: 0 }} label="Medición máx.">
                            <Input />
                        </Form.Item>
                    </FiltroVelocidad>
                    <Form.Item style={{ marginBottom: 0 }} name={"dateRange"}>
                        <DatePicker.RangePicker format={"DD-MM-YYYY"} onChange={() => setFilter(form.getFieldsValue())} style={{ width: "100%" }} locale={locale} />
                    </Form.Item>

                    <Form.Item rules={[{ type: 'integer', message: 'Ingrese un número entero' }]} name={"limit"} style={{ marginBottom: 0 }} label={"Limitar cantidad"}>
                        <InputNumber />
                    </Form.Item>
                    {/*<Button htmlType="submit" type="primary" icon={<CheckOutlined />} >Compartir</Button>*/}
                    <TotalResultados><p>Total: </p>{loadingTotal ? <StyledSpin size="small" /> : total ?? "-"}</TotalResultados>
                </div>


                {props.ubicacionInfractorFilter && <FiltroUbicacion>
                    <Form.Item style={{ marginBottom: 0 }} name={"infractorFilterType"}>
                        <Select placeholder={"Tipo de filtrado (infractor)"} allowClear>
                            <Select.Option value={0}>Excluir infractores de</Select.Option>
                            <Select.Option value={1}>Incluir solo infractores de</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={"Provincia"}
                        style={{ marginBottom: 0, width: '200px' }}
                        name={"infractorProvincia"}
                    >
                        <InputUbicacion placeholder="Provincia" type="PROVINCIA" />
                    </Form.Item>
                    <Form.Item
                        label={"Código postal"}
                        style={{ marginBottom: 0 }}
                        name={"infractorCodigoPostal"}
                    >
                        <TagInput tagsContainerStyle={{ display: 'grid', gridTemplateColumns: 'auto auto auto', gap: '0.5rem' }} textButton="Agregar" />
                    </Form.Item>

                </FiltroUbicacion>}

                {props.ciudadesInfractorFilter &&
                    <>
                        <strong>Excluir por ciudad</strong>
                        <FiltroCiudadExcluir>
                            <Form.Item name={"filterExcluirParanaenses"} valuePropName="checked">
                                <Checkbox>Excluir Paranaenses</Checkbox>
                            </Form.Item>
                            <Form.Item name={"filterExcluirRosario"} valuePropName="checked">
                                <Checkbox>Excluir Rosario (CP 2000)</Checkbox>
                            </Form.Item>
                            <Form.Item name={"filterExcluirSantaFe"} valuePropName="checked">
                                <Checkbox>Excluir Santa Fe (CP 3000)</Checkbox>
                            </Form.Item>
                        </FiltroCiudadExcluir>
                        <strong>Incluir por ciudad</strong>
                        <FiltroCiudadIncluir>
                            <Form.Item name={"filterIncluirSantaFe"} valuePropName="checked">
                                <Checkbox>Incluir Santa Fe (CP 3000)</Checkbox>
                            </Form.Item>
                            <Form.Item name={"filterIncluirRosario"} valuePropName="checked">
                                <Checkbox>Incluir Rosario (CP 2000)</Checkbox>
                            </Form.Item>
                        </FiltroCiudadIncluir>
                    </>
                }

                <FiltrosExtraFooter>{props?.children}</FiltrosExtraFooter>
            </FiltrosExtra>
        </>)
});
